
import React, { useRef,useState,useEffect} from 'react'

import "./SaveClientContact.scss"
import DashboardHeader from '../../components/dashboardheader/DashboardHeader'
import { useOutletContext,useLocation, Navigate, useNavigate } from "react-router-dom";
import CollapsibleHeader from '../../components/collapsibleheader/CollapsibleHeader';
import MultiValueInput from '../../components/communicationinput/MultiValueInput';
import encryptedapiRequest from '../../lib/encryptedapiRequest';
import Comp_ClientContactTypes from '../../components/datacontrols/controlClientContactType';
import Comp_Colonies from '../../components/datacontrols/controlColony';
import apiRequest from '../../lib/apiRequest';
import { setPendingContact } from '../../lib/contactReturnStore';
import CancelButton from '../../components/buttons/cancelbutton/CancelButton';


export default function SaveClientContact() {
    const { toggleMenu } = useOutletContext();
    const location=useLocation();
    const mode = location.state?.mode;  

    const navigate=useNavigate();


    const clientcontact=location.state?.clientcontact;
    const clientContactId=location.state?.clientcontactid;
    const clientid=location.state?.clientid;


    // const phoneRef=useRef();
    // const {tagrefColony,tagrefClientContactType,phoneRef,emailRef}=useRef();

    const tagrefColony = useRef(null);
    const tagrefClientContactType = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);


    // mode= 0 means new client contact
    // mode= 1 means edit client contact

        // console.log("FULL LOCATION:", location);

    // console.log("mode",mode);
    // console.log("clientContactId",clientContactId) ;

    // console.log("intitial clientcontact",clientcontact);
    // console.log("intitial clientid",clientid);

    
  const [clientContactData, setClientContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [formData, setFormData] = useState(null); // Initially null to avoid premature rendering


  const [formData, setFormData] = useState({
    contactname: "",
    contacttypes: [],
    colonyinterests: [],
    contactphones: [],
    contactemails: []
  });

const fetchClientData = async () => {
    let fetchedData = null; // Declare outside try block
    try {
      // console.log("Fetching user data... of currentuser.id", currentUser.id);

      // const res = await apiRequest.get(`/users/userdetails/${currentUser.id}`);

      if (mode===1){
        const res = await encryptedapiRequest.get(`/clients/contacts/${clientContactId}`);
    
        if (res.data && res.data.length > 0) {
          // console.log("res data:", res.data[0]);
          fetchedData = res.data[0];
          setClientContactData(fetchedData);
        } else {
          console.log("ClientContact id:", clientContactId);
          setError("ClientContact data not found.");
        }

      }
      else{
        setClientContactData(null)
      }

    } catch (err) {
      console.error("Error fetching Client Contact data:", err);
      setError("Failed to load Client Contact data.");
    } finally {
      setLoading(false);

      // console.log("User data finally:", fetchedData);
    }
  };
  


  // Fetch user data once when the component mounts
useEffect(() => {
  // console.log("fetching client contact data");
  fetchClientData();
}, []);


useEffect(() => {
  if (!clientContactData) return;
  // console.log("setting up formData with clientContactData",clientContactData);
  // Map and rename colonyname to name
  // const colonies = JSON.parse(clientContactData.contactcolonies).map(({ colonyname, ...rest }) => ({
  //   name: colonyname,
  //   ...rest
  // }));


  // const colonies = Array.isArray(clientContactData.contactcolonies)
  // ? clientContactData.contactcolonies
  // : [];

// let colonies = JSON.parse(clientContactData.contactcolonies);

let colonies = [];

try {
  const parsed = JSON.parse(clientContactData?.contactcolonies);
  colonies = Array.isArray(parsed) ? parsed : [];
} catch (e) {
  colonies = [];
}

// console.log("clientcontact.colonies", colonies);



// console.log("clientcontact.colonies",colonies)
// Replace "colony" key with "name"
colonies = colonies.map(item => {
    return {
        id: item.id,
        name: item.colony,
        clientcontactcolonyid: item.clientcontactcolonyid
    };
});


// console.log(
//   "setting up colonies",
//   colonies,
//   "with clientContactData.contactcolonies",
//   clientContactData.contactcolonies
// );

  const phones=Array.isArray(
    JSON.parse(clientContactData.contactnumbers ||"[]")
  )
  ?JSON.parse(clientContactData.contactnumbers ||"[]").map(
    ({ number, ...rest }) => ({
    value: number,
    ...rest
  })
)
:[];

const emails = Array.isArray(
  JSON.parse(clientContactData.contactemails || "[]")
)
  ? JSON.parse(clientContactData.contactemails || "[]").map(
      ({ email, ...rest }) => ({
        value: email,
        ...rest
      })
    )
  : [];

  setFormData({
    contactname: clientContactData.contactname || "",
    contacttypes: JSON.parse(clientContactData?.contacttypes) || [],
    colonyinterests: colonies || [],
    contactphones: phones || [],
    contactemails: emails|| "",
    // contactproperties: userData.address1 || "",
    // contactrequirements: userData.address2 || "",
  
  });
      // console.log("formData",formData);

}, [clientContactData]);



  // const handleCheck = async (e) => {
  //   e.preventDefault();

  //     try {
  //         // const all = phoneRef.current.getAllValues();
  //         // const active = phoneRef.current.getValues();

  //         // console.log(all);    // includes add/delete/default
  //         // console.log(active); // excludes deleted
   
  //       // phoneRef.current.setValues([
  //       //   "9999999999",
  //       //   { id: 200, value: "8888888888" }
  //       // ]);

  //       // all working
        
  //     } catch (error) {
        
  //     }

  // }

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  function BuildPayload(){

      if (!formData) return;
        let colonyids = tagrefColony.current?.getColonyTags();
        let clientcontacttypes=tagrefClientContactType.current?.getClientContactTypeTags();
        // console.log("colonyids",colonyids);
        // console.log("clientcontacttypes",clientcontacttypes);



        let clientphones=phoneRef.current?.getAllValues();
        let clientemails=emailRef.current?.getAllValues();

        let clientcontact=new Object;
        clientcontact.contactname=formData.contactname;
        clientcontact.clientid=clientid;
        clientcontact.clientcontactid=clientContactId;

        clientcontact.contacttypes=clientcontacttypes;
        clientcontact.contactcolonies=colonyids;
        clientcontact.contactnumbers=clientphones;
        clientcontact.contactemails=clientemails; 

        const payload = new FormData();
        payload.append("clientcontact",JSON.stringify(clientcontact))
        

        // payload.append("contactname",formData.contactname)
        // payload.append("colonyinterests", JSON.stringify(colonyids));
        // payload.append("contacttypes", JSON.stringify(clientcontacttypes));
        // payload.append("contactphones", JSON.stringify(clientphones));
        // payload.append("contactemails", JSON.stringify(clientemails));


        // for (const [key, value] of payload.entries()) {
        //   try {
        //     console.log(key, JSON.parse(value));
        //   } catch {
        //     console.log(key, value);
        //   }
        // }



        // console.log("Submitting payload:", payload);

    return payload;

  }

const handleDummySave = async (e) => {
    e.preventDefault();

    const savedContact={
    "id": "3616",
    "contactname": "new contact",
    "contacttypes": "[{\"id\": 2, \"type\": \"Builder\", \"clientcontacttagid\": 1316}]",
    "contactcolonies": "[{\"id\": 286, \"colony\": \"Vasant Kunj\", \"clientcontactcolonyid\": 2}]",
    "contactnumbers": "[{\"id\": 4654, \"number\": \"7788776677\"}]",
    "contactemails": null
}

  
    setPendingContact(savedContact);

    // console.log("onSaveContact savedContact:", savedContact);
    // ✅ Navigate back and pass contact
    navigate(-1, {
      state: {
        newContact: savedContact
      }
    });



}



  const handleSave = async (e) => {
    e.preventDefault();
    let res;
    try {
      const payload=BuildPayload();

      if (mode===0){
        /// adding
        // console.log("adding contact",payload)
        res = await apiRequest.post(`/clients/contacts/`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

      }
      else{
        /// updating
        // console.log("updating contact",payload)
        res = await apiRequest.post(`/clients/contacts/${clientContactId}`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });


      }



 // ✅ Extract saved contact from response
    // console.log("contact res after adding data:",res);
    const savedContact = res?.data?.data[0];

    const returnObject={
        action:mode===0 ?'add':'update',
        returnData:savedContact
    }

    

    console.log("sending saved contact",returnObject);

    
    
    // const safeParseJSON = (value) => {
    //     if (!value) return []; // null, undefined, empty string → empty array
    //     if (Array.isArray(value)) return value; // already parsed
    //     try {
    //       const parsed = JSON.parse(value);
    //       return Array.isArray(parsed) ? parsed : [];
    //     } catch (err) {
    //       console.warn("Failed to parse JSON:", value, err);
    //       return [];
    //     }
    //   };

    //   // Usage
    //   savedContact.contacttypes = safeParseJSON(savedContact.contacttypes).join(", ");
    //   savedContact.contactcolonies = safeParseJSON(savedContact.contactcolonies).join(", ");

    // savedContact.conctacttypes = JSON.parse(savedContact.contacttypes).join(", ");
    // savedContact.contactcolonies = JSON.parse(savedContact.contactcolonies).join(", ");
      

    setPendingContact(returnObject);

    // console.log("onSaveContact savedContact:", savedContact);
    // ✅ Navigate back and pass contact
    // navigate(-1, {
    //   state: {
    //     newContact: savedContact
    //   }
    // });

    navigate(-1)

    } catch (err) {
      console.log(err);
    }



  }






  if (loading) return <p>Loading Contact data...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!formData) return <p>Loading form...</p>; // Prevents errors if formData is null




    return (
    <>
    <div className="SaveContactPage">
        <div className="PageHeader">
          <DashboardHeader title={mode===0?"New Contact":"Save Contact"} toggleMenu={toggleMenu} />
        </div>

        <div className="pageContent">

              <form className="formGrid">

                <div className="FormContainer">

                  <div className="FormRow">
                      <label>Contact Name</label>

                      <div className="inputCol">

                          <input 
                            type="text" 
                            placeholder="Enter contact name" 
                            name="contactname"
                            value={formData.contactname}
                            onChange={handleChange}
                          />

                      </div>
                  </div>

                  <div className="FormRow">
                      <label>Contact Type</label>
                      {/* <input type="text" placeholder="Enter contact type" /> */}

                      <div className="inputCol">
                          <Comp_ClientContactTypes
                            ref={tagrefClientContactType}
                            // displayKey=""
                            // defaultTags={formData.contacttypes}
                            selectedTags={formData.contacttypes}
                            setSelectedTags={(tags) => setFormData(prev => ({ ...prev, contacttypes: tags }))}  
                            />
                            
                            
                          {/* </Comp_ClientContactTypes>                     */}


                      </div>

                  </div>

                  <div className="FormRow">
                      <label>Colony Interests</label>

                      <div className="inputCol">
                          {/* {console.log("formData while rendering ",formData)} */}
                          <Comp_Colonies
                            // style={{ width: "100%" }}
                            // maxTags={1}
                            ref={tagrefColony}
                            // displayKey="colony"

                            // parentKey='colonyaddress'

                            defaultTags={formData.colonyinterests}
                            selectedTags={formData.colonyinterests}
                            setSelectedTags={(tags) => setFormData(prev => ({ ...prev, colonyinterests: tags }))}  

                            // onColonyChangeTag={handleColonyChange}
                          />

                      </div>


                  </div>

                  <CollapsibleHeader title="Phones" defaultOpen={false}>
                      <MultiValueInput
                          ref={phoneRef}
                          type="mobile"
                          placeholder="Type mobile number and press Enter"
                          defaultValues={formData.contactphones}
                          // defaultValues={[
                          //     { id: 101, value: "9876543210" },
                          //     { id: 102, value: "9123456789" }
                          //   ]}
                          
                        >
                      </MultiValueInput>

                  </CollapsibleHeader>

                  <CollapsibleHeader
                    title="Emails"
                    defaultOpen={false}
                    // rightContent={<button>Add</button>}
                  >



                          <MultiValueInput
                              ref={emailRef}

                              type="email"
                              placeholder="Type email and press Enter"
                              defaultValues={formData.contactemails}
                              // defaultValues={[
                              //     { id: 101, value: "rajeshkhetrapal@gmail.com" },
                              //     { id: 102, value: "bhoomi.indiarealtors@gmail.com" }
                              //   ]}
                              
                            >
                          </MultiValueInput>





                  </CollapsibleHeader>

                  <CollapsibleHeader title="Properties" defaultOpen={false}
                  >
                  </CollapsibleHeader>

                  <CollapsibleHeader title="Requirements" defaultOpen={false}>
                  </CollapsibleHeader>




                </div>
                {/* formcontainter */}
              </form>
              


        </div>

        {/* <button onClick={handleCheck}> Check</button> */}

        <div className="buttonContainer">

          <button onClick={handleSave}> Save</button>
          <CancelButton></CancelButton>

        </div>


    </div>

    </>
  )
}
